import {
  useRentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser,
  type UserManagementCompanyPropertyDetailsDto,
  type UserManagementUnrecognizedUserDto,
} from '@zg-rentals/rental-manager-env';
import { InlineFeedback, Spinner, TextButton } from '@zillow/constellation-10';

interface Props {
  previewProperties: (listings: Array<UserManagementCompanyPropertyDetailsDto>) => void;
  user: UserManagementUnrecognizedUserDto;
}

export const UnrecognizedUserPropertyWidget = ({ previewProperties, user }: Props) => {
  const { data, isFetching, error } = useRentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser({
    zuid: user.zuid,
  });
  if (isFetching || !data) {
    return <Spinner />;
  }
  if (error) {
    return <InlineFeedback tone="critical">Preview unavailable</InlineFeedback>;
  }
  return <TextButton onClick={() => previewProperties(data.properties)}>{data.properties.length}</TextButton>;
};
